const config = {
  graphqlEndpoint: process.env.REACT_APP_AWS_GRAPHQL_END_POINT,
  region: process.env.REACT_APP_AWS_REGION,
  authenticationType: process.env.REACT_APP_AWS_AUTHENTICATION_TYPE,
  apiKey: 'null'
};

export default config;
